import AccessDenied from 'core/component/view/access-denied';
import { storedUserIsStrictAppAdmin } from 'core/lib/data/app-user-admin.lib';

type Props = {
    children: React.ReactNode;
    module: string;
};

/**
 * Data maintenance and similar tools: AppUser.isAdmin only (not Administrator role).
 */
export default function RequireAppAdmin({ children, module }: Props) {
    if (!storedUserIsStrictAppAdmin()) {
        return <AccessDenied access="access" module={`${module} (admin users only)`} />;
    }
    return <>{children}</>;
}
